export class SVGEditorContext {
    height = 1024;

    constructor(height) {
        this.height = height;
    }
}